import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const BASE = "https://pdninvestor.com";

const LABELS: Record<string, string> = {
  domains: "Domains",
  about: "About",
  contact: "Contact",
  blog: "Blog",
  faq: "FAQ",
  sales: "Sales",
  escrow: "Escrow",
  privacy: "Privacy",
  terms: "Terms",
  compare: "Compare",
  search: "Search",
  category: "Category",
  extension: "Extension",
};

const prettify = (slug: string) =>
  decodeURIComponent(slug)
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

const BreadcrumbSchema = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  const parts = pathname.split("/").filter(Boolean);
  const items: Array<{ name: string; url: string }> = [
    { name: "Home", url: `${BASE}/` },
  ];
  let acc = "";
  parts.forEach((p) => {
    acc += `/${p}`;
    items.push({ name: LABELS[p] ?? prettify(p), url: `${BASE}${acc}` });
  });

  if (items.length < 2) return null;

  const json = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: it.url,
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(json)}</script>
    </Helmet>
  );
};

export default BreadcrumbSchema;
